import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/** Cuerpo de POST /api/public/access-requests. */
export interface AccessRequestPayload {
  fullname: string;
  companyName: string;
  email: string;
  phone?: string;
  message?: string;
  /**
   * Honeypot anti-bots. El input existe en el DOM pero está oculto, así que una
   * persona lo envía siempre vacío y un bot que autocompleta todo lo rellena.
   * El backend descarta en silencio la solicitud si llega con contenido.
   */
  website?: string;
}

export interface AccessRequestAck {
  received: boolean;
  message: string;
}

/**
 * Solicitudes de acceso a Partner CRM.
 *
 * <p>El producto se vende de forma asistida: no hay alta de cuenta en
 * auto-servicio. Este endpoint NO crea usuario ni empresa — sólo deja constancia
 * del interés para que el equipo comercial lo atienda y, si procede, cree la
 * empresa e invite al administrador.
 */
@Injectable({ providedIn: 'root' })
export class AccessRequestApiService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}api/public/access-requests`;

  submit(payload: AccessRequestPayload): Observable<AccessRequestAck> {
    return this.http.post<AccessRequestAck>(this.url, payload);
  }
}
